import { z } from "zod";

export const aiGeneratedQuestionSchema = z.object({
  id: z.string(),
  text: z.string(),
  type: z.enum(["scale", "yes_no", "multi_select", "free_text"]),
  options: z.array(z.string()).optional(),
});
export type AiGeneratedQuestion = z.infer<typeof aiGeneratedQuestionSchema>;

export const aiTestRunResponseSchema = z.object({
  questions: z.array(aiGeneratedQuestionSchema),
  modelVersion: z.string(),
  quotaRemaining: z.number(),
});
export type AiTestRunResponse = z.infer<typeof aiTestRunResponseSchema>;
